import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import common from './modules/common'
import userAccount from './modules/userAccount'
import VuexPersistence from 'vuex-persist'
import 'babel-polyfill';
import 'es6-promise/auto'

require('es6-promise').polyfill();

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    key: 'vuex',
    storage: window.sessionStorage
})

export default new Vuex.Store({
    modules: {
        common,
        userAccount
    },
    getters,
    plugins: [vuexLocal.plugin],
    strict: true
})


// WEBPACK FOOTER //
// ./src/store/index.js